<div id="head-nav" class="navbar navbar-default navbar-fixed-top cookiebar" *ngIf="!cookieMsgRead">
  <div class="container-fluid">
    <div class="navbar-header text-center full-width padding-sides-9">
      {{'COOKIES_MESSAGE' | translate}}
      <button type="button" class="btn btn-sm btn-default" [title]="'OK' | translate" (click)="dismissCookieMessage()">
        <i class="fas fa-check"></i>&nbsp;{{'OK' | translate}}
      </button>
    </div>
  </div>
</div>
<div id="cl-wrapper" class="login-container login-theme">

  <div class="login-message" *ngIf="loginMessage" [innerHTML]="loginMessage | safeHtml"></div>

  <div class="login-columns" [ngClass]="newsList.length > 0 ? 'width-950' : 'width-450'">

    <div class="login-form">
      <div class="block-flat">
        <div class="header">
          <h3 class="text-center">
            <img [src]="logoUrl" class="img-responsive logo-img" alt="">
          </h3>
        </div>
        <div *ngIf="form">
          <form [formGroup]="form" (ngSubmit)="onSubmit()" class="form-horizontal">
            <div class="content">

              <h3 *ngIf="!HIDE_PORTAL_NAME_LOGIN" class="title text-center"><strong>{{PORTAL_NAME | translate}}</strong>
              </h3>
              <h4 class="title" *ngIf="!showAuthenticationText">
                <strong>{{'AUTHENTICATION' | translate}}</strong>
              </h4>
              <h4 class="title" *ngIf="showAuthenticationText">
                <strong>{{'AUTHENTICATION_TEXT' | translate}}</strong>
              </h4>

              <div class="alert alert-danger" *ngIf="formAllErrors.length > 0">
                <i class="fas fa-times-circle sign"></i>
                <strong>{{'ERROR'|translate}}:</strong> {{formAllErrors}}
              </div>

              <div class="form-group">
                <div class="col-sm-12">
                  <mat-form-field class="full-width">
                    <i matPrefix class="fas fa-user"></i>
                    <input type="text" matInput placeholder="{{'USERNAME'|translate}}" formControlName="username">
                  </mat-form-field>
                  <mat-error *ngIf="formErrors.username" class="font75per"> {{ formErrors.username }}</mat-error>
                </div>
              </div>

              <div class="form-group" *ngIf="!hideCompany">
                <div class="col-sm-12">
                  <mat-form-field class="full-width">
                    <i matPrefix class="fas fa-building"></i>
                    <input type="text" matInput placeholder="{{'COMPANY'|translate}}" formControlName="company">
                  </mat-form-field>
                  <mat-error *ngIf="formErrors.company" class="font75per"> {{ formErrors.company }}</mat-error>
                </div>
              </div>

              <div class="form-group">
                <div class="col-sm-12">
                  <mat-form-field class="full-width">
                    <i matPrefix class="fas fa-lock"></i>
                    <input type="password" matInput placeholder="{{'PASSWORD'|translate}}" formControlName="password">
                  </mat-form-field>
                  <button type="button" id="tooltipOn" hidden (click)="pop.show()"></button>
                  <button type="button" id="tooltipOff" hidden (click)="pop.hide()"></button>
                  <mat-error *ngIf="formErrors.password" class="font75per"> {{ formErrors.password }}</mat-error>
                </div>
              </div>

              <div class="form-group">
                <div class="col-sm-12">
                  <mat-checkbox formControlName="rememberMe" (cdkObserveContent)="_onContentChanges()">{{'REMEMBERME' |
                    translate}}</mat-checkbox>
                </div>
                <div class="col-sm-12" *ngIf="termsConditionsUrl" style="position: relative; height: 30px; ">
                  <div>
                    <mat-checkbox id="termsConditions" formControlName="termsConditions"
                      (change)="onChangeTermsConditions($event)">{{'TERMS_CONDITIONS'
                      | translate}}</mat-checkbox>
                  </div>
                  <div
                    style="position: absolute; top: 40%; left: 48%; -ms-transform: translate(-50%,-50%); transform: translate(-50%,-50%);">
                    <a [routerLink]="['/terms-conditions']" target="_blank">
                      <i class="fas fa-info"></i></a>
                  </div>
                </div>
              </div>

              <!-- Botões -->
              <div class="form-group margin-bottom-30">

                <div class="col-sm-12">
                  <div class="pull-left text-left display-grid">                
                    <a [routerLink]="['/register-supplier']" *ngIf="isSignUpSupplier">{{'Registar fornecedor.' | translate}}</a> 
                    <a [routerLink]="['/recovery']">{{'FORGOTDATA' | translate}}</a>
                    <a [routerLink]="['/register']" *ngIf="isSignUp">{{'SIGN_UP' | translate}}</a>
                  </div>
                  <button type="submit" class="btn btn-primary pull-right" title="{{'ENTER' | translate}}"
                    [disabled]="!form.valid || (termsConditionsUrl && !(form.get('termsConditions').value))">
                    <i class="fas fa-sign-in-alt"></i>&nbsp;{{'ENTER' | translate}}
                  </button>
                </div>

                <div class="col-sm-12" *ngIf="this.showAuthenticationMicrosoft">
                  <button class="btn btn-basic pull-right"
                    type="button"
                    style="color: rgb(0,120,212); background-color: rgb(252, 253, 253); font-weight: bold;"
                    title="{{'Microsoft Login' | translate}}" (click)="microsoftLogin()">
                    <img style="width: 16px; height: 16px; "
                      src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pg0KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE5LjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPg0KPHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJDYXBhXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4Ig0KCSB2aWV3Qm94PSIwIDAgNTEyIDUxMiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNTEyIDUxMjsiIHhtbDpzcGFjZT0icHJlc2VydmUiPg0KPHBhdGggc3R5bGU9ImZpbGw6IzRDQUY1MDsiIGQ9Ik0yNzIsMjQwaDI0MFYxNmMwLTguODMyLTcuMTY4LTE2LTE2LTE2SDI3MlYyNDB6Ii8+DQo8cGF0aCBzdHlsZT0iZmlsbDojRjQ0MzM2OyIgZD0iTTI0MCwyNDBWMEgxNkM3LjE2OCwwLDAsNy4xNjgsMCwxNnYyMjRIMjQweiIvPg0KPHBhdGggc3R5bGU9ImZpbGw6IzIxOTZGMzsiIGQ9Ik0yNDAsMjcySDB2MjI0YzAsOC44MzIsNy4xNjgsMTYsMTYsMTZoMjI0VjI3MnoiLz4NCjxwYXRoIHN0eWxlPSJmaWxsOiNGRkMxMDc7IiBkPSJNMjcyLDI3MnYyNDBoMjI0YzguODMyLDAsMTYtNy4xNjgsMTYtMTZWMjcySDI3MnoiLz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjwvc3ZnPg0K" />
                    &nbsp;{{'Sign in with Microsoft' | translate}}
                  </button>
                </div>

                <div class="col-sm-12" *ngIf="this.showAuthenticationGoogle">
                  <button *ngIf="authenticationGoogleLabel == 'Google'"
                    class="btn btn-basic pull-right"
                    type="button"
                    style="color: rgb(0,120,212); background-color: rgb(252, 253, 253); font-weight: bold;"
                    title="{{'Google Login' | translate}}" (click)="googleLogin()">
                    <img style="width: 18px; height: 18px; "
                      src="https://imagensemoldes.com.br/wp-content/uploads/2020/04/imagem-google-logo-com-fundo-transparente-1.png" />
                    &nbsp;{{'ENTER_WITH' | translate}} {{authenticationGoogleLabel}}
                  </button>

                  <button *ngIf="authenticationGoogleLabel != 'Google'"
                    type="button"
                    class="btn btn-basic pull-right"
                    style="font-weight: bold;"
                    (click)="googleLogin()">
                    &nbsp;{{'ENTER_WITH' | translate}} {{authenticationGoogleLabel}}
                  </button>
                </div>

              </div>

              <!-- Email de suporte -->
              <div class="form-group margin-bottom-30" *ngIf="SUPPORT_EMAIL">
                <div class="col-sm-12 text-center">
                  <a class="color-default" [href]="SUPPORT_EMAIL"
                    target="_blank"><strong>{{'WANT_TO_ACCESS_SUPPORT'|translate}}</strong></a>
                </div>
              </div>

            </div>
            <div class="foot">
              <!-- <div class="pull-left text-left display-grid">
                <a [routerLink]="['/recovery']">{{'FORGOTDATA' | translate}}</a>
                <a [routerLink]="['/register']" *ngIf="isSignUp">{{'SIGN_UP' | translate}}</a>
              </div>
              <button type="submit" class="btn btn-primary" title="{{'ENTER' | translate}}" [disabled]="!form.valid">
                <i class="fas fa-sign-in-alt"></i>&nbsp;{{'ENTER' | translate}}
              </button> -->

              <div class="text-center">
                <a class="color-default small" [href]="loginFooterUrl" target="_blank"
                  [innerHtml]="loginFooterText"></a>
              </div>
            </div>
          </form>
        </div>

        <!-- LOGINMFA -->
        <div *ngIf="formLoginMFA">
          <form [formGroup]="formLoginMFA" class="form-horizontal" style="align-content: center;">
            <br>
            <h2 style="text-align:center;">{{'MULTIFACTOR_AUTHENTICATION' | translate}}</h2>
            <p style="text-align:center;">{{this.authenticationMFAText}}</p>
            <br>
            <div class="row">
              <div class="col-sm-12 col-md-12 "
                style="align-content: center; padding-right: 100px; padding-left: 100px;">
                <mat-form-field>
                  <input maxlength="6" type="text" style="font-size:64px; text-align:center; padding: 0;" matInput
                    placeholder="" formControlName="AuthCode" (change)="onInputCodeChange()">
                </mat-form-field>
              </div>
            </div>
            <br>
            <h4 *ngIf="this.successMfaMessage" style="text-align:center; padding: 0;">{{this.successMfaMessage}}</h4>
            <h4 *ngIf="this.errorMfaMessage" style="text-align:center; padding: 0;color: red;">{{this.errorMfaMessage}}</h4>
            <br><br>
            <div class="form-group margin-bottom-30 ">
              <div class="col-sm-6 text-right" style="padding-left: 60px">
                <button type="button" class="btn pull-left" title="{{'BUTTON.BACK' | translate}}"
                  (click)="backToLogin()">
                  <i class="fas fa-arrow-left"></i>&nbsp;{{'BUTTON.BACK' | translate}}
                </button>
              </div>
              <div class="col-sm-6 text-right" style="padding-right: 60px">
                <button type="button" class="btn pull-right" title="{{'VALIDATE' | translate}}"
                  (click)="onInputCodeChange()">
                  <i class="fas fa-check"></i>&nbsp;{{'VALIDATE' | translate}}
                </button>
              </div>
            </div>
            <div class="foot">

              <div class="text-center">
                <a class="color-default small" [href]="loginFooterUrl" target="_blank"
                  [innerHtml]="loginFooterText"></a>
              </div>
            </div>
          </form>
        </div>

        <div *ngIf="formChangePassword">
          <form [formGroup]="formChangePassword" class="form-horizontal">
            <div class="content">
              <!-- <h3 class="title">{{'AUTHENTICATION' | translate}}</h3>
              <h5>{{'TO_ACCESS_THE_PORTAL_YOU_HAVE_TO_CHANGE_YOUR_PASSWORD' | translate}}</h5> -->

              <h3 class="title text-center"><strong>{{PORTAL_NAME | translate}}</strong></h3>
              <h4 class="title"><strong>{{'AUTHENTICATION' | translate}}</strong></h4>
              <h5><strong>{{'TO_ACCESS_THE_PORTAL_YOU_HAVE_TO_CHANGE_YOUR_PASSWORD' | translate}}</strong></h5>


              <div class="alert alert-danger" *ngIf="formAllErrors.length > 0">
                <i class="fas fa-times-circle sign"></i>
                <strong>{{'ERROR'|translate}}:</strong> {{formAllErrors}}
              </div>

              <div class="form-group">
                <div class="col-sm-12">
                  <mat-form-field class="full-width">
                    <i matPrefix class="fas fa-lock"></i>
                    <input type="password" matInput placeholder="{{'NEW_PASSWORD'|translate}}"
                      formControlName="NewPassword">
                  </mat-form-field>
                  <!-- <button type="button" id="tooltipOn" hidden (click)="pop.show()"></button>
                <button type="button" id="tooltipOff" hidden (click)="pop.hide()"></button> -->
                  <mat-error *ngIf="formErrors.NewPassword" class="font75per"> {{ formErrors.NewPassword }}
                  </mat-error>
                </div>
              </div>

              <div class="form-group">
                <div class="col-sm-12">
                  <mat-form-field class="full-width">
                    <i matPrefix class="fas fa-lock"></i>
                    <input type="password" matInput placeholder="{{'CONFIRM_NEW_PASSWORD'|translate}}"
                      formControlName="ConfirmNewPassword">
                  </mat-form-field>
                  <!-- <button type="button" id="tooltipOn" hidden (click)="pop.show()"></button>
                <button type="button" id="tooltipOff" hidden (click)="pop.hide()"></button> -->
                  <mat-error *ngIf="formErrors.ConfirmNewPassword" class="font75per">
                    {{ formErrors.ConfirmNewPassword }}
                  </mat-error>
                </div>
              </div>
              <!-- Botões -->
              <div class="form-group margin-bottom-30">
                <div class="col-sm-12 text-right">
                  <button type="button" class="btn pull-left no-margin-left" title="{{'BUTTON.CANCEL' | translate}}"
                    (click)="backToLogin()">
                    <i class="fas fa-arrow-left"></i>&nbsp;{{'BUTTON.CANCEL' | translate}}
                  </button>
                  <button type="button" class="btn btn-primary pull-right" title="{{'BUTTON.SAVE' | translate}}"
                    (click)="changePassword()" [disabled]="!formChangePassword.valid">
                    <i class="fas fa-sign-in-alt"></i>&nbsp;{{'BUTTON.SAVE' | translate}}
                  </button>
                </div>
              </div>
              <!-- Email de suporte -->
              <div class="form-group margin-bottom-30" *ngIf="SUPPORT_EMAIL">
                <div class="col-sm-12 text-center">
                  <a class="color-default" [href]="SUPPORT_EMAIL"
                    target="_blank"><strong>{{'WANT_TO_ACCESS_SUPPORT'|translate}}</strong></a>
                </div>
              </div>

            </div>
            <div class="foot">
              <!-- <button type="button" class="btn btn-default" title="{{'BUTTON.CANCEL' | translate}}"
                (click)="backToLogin()">
                <i class="fas fa-arrow-left"></i>&nbsp;{{'BUTTON.CANCEL' | translate}}
              </button>
              <button type="button" class="btn btn-primary" title="{{'BUTTON.SAVE' | translate}}"
                (click)="changePassword()" [disabled]="!formChangePassword.valid">
                <i class="fas fa-sign-in-alt"></i>&nbsp;{{'BUTTON.SAVE' | translate}}
              </button> -->

              <div class="text-center">
                <a class="color-default small" [href]="loginFooterUrl" target="_blank"
                  [innerHtml]="loginFooterText"></a>
              </div>
            </div>

          </form>
        </div>
      </div>
      <!-- <div class="text-center out-links">
        <a [href]="loginFooterUrl" target="_blank" [innerHtml]="loginFooterText"></a>
      </div> -->
    </div>

    <!-- Imagens -->
    <div class="slideshow" *ngIf="newsList.length > 0">
      <ngu-carousel [inputs]="carouselOne" (carouselLoad)="myfunc($event)" [dataSource]="newsList">
        <ngu-tile NguCarouselItem *nguCarouselDef="let news">
          <a class="pointer" [href]="news.ExternalLink ? news.ExternalLink : 'javascript:void(0);'"
            [target]="news.ExternalLink ? '_blank' : '_self'">
            <img class="img-responsive image-center" [src]="news.AssociatedImageFile ? news.AssociatedImageFile : ''"
              [alt]="news.Title" />
          </a>
        </ngu-tile>

        <!-- Controls -->
        <a class="left carousel-control" role="button" NguCarouselPrev *ngIf="newsList && newsList.length > 1">
          <span class="glyphicon glyphicon-chevron-left" aria-hidden="true"></span>
          <span class="sr-only">Previous</span>
        </a>
        <a class="right carousel-control" role="button" NguCarouselNext *ngIf="newsList && newsList.length > 1">
          <span class="glyphicon glyphicon-chevron-right" aria-hidden="true"></span>
          <span class="sr-only">Next</span>
        </a>
      </ngu-carousel>
    </div>

  </div>

  <!-- Língua -->
  <div class="dropdown-country text-right" *ngIf="showLoginLanguages">
    <div class="btn-group dropup">
      <button type="button" data-toggle="dropdown" class="btn btn-default dropdown-toggle no-padding">
        <img [src]="'./assets/img/flags/' + locale + '.svg'" />
      </button>
      <ul role="menu" class="dropdown-menu dropdown-menu-right">
        <li *ngFor="let language of languages">
          <a class="pointer" (click)="changeLocale(language.Code)">
            <img [src]="'./assets/img/flags/' + language.Code + '.svg'" />
          </a>
        </li>
      </ul>
    </div>
  </div>

</div>